<template>
  <div>
    <div class="event-label-title">
      <label class="event-title-label-box font14 mr16">
        <p><span style="font-size: 0.8em">响应组件：</span>{{ innerElementLabel }}</p></label
      >
    </div>
    <div class="update_settings">
      <cx-check-box :value.sync="transitionProxy">过渡动画</cx-check-box>
      <slider-and-input
        :sliderMax="20"
        v-if="transitionProxy"
        suffix="s"
        class="mt8"
        :value.sync="transitionTimeProxy"
      />
      <cx-select
        title="更新方式"
        class="mt16"
        :value.sync="eventUpdateTypeProxy"
        :selectOptions="optionTypeSelectOptions"
      />
      <div class="mt16">
        <div class="variable_title">
          <p>接口传参</p>
          <div class="icon_box">
            <div @click="addUrlParamItem" class="icon-portal-plus-small plugin_title"></div>
          </div>
        </div>
        <div v-for="(item, key) in urlParam" :key="key" class="variable_item mb8">
          <div class="right_font"><span @click="delUrlParam(key)" class="icon-portal-delete plugin_title"></span></div>
          <div class="variable_set mt16">
            <div class="mr8 param_name">参数值</div>
            <div class="param_value">
              <el-input
                class="mr8"
                :value="item.itemValue"
                @input="changeUrlParamValueStr(key, $event)"
                @change="checkUrlParamValue(key, $event)"
                placeholder="请输入参数值"
              ></el-input>
              <cx-select
                class="variable-tips"
                :value="''"
                @change="selectUrlParamVariable(item.itemValue, key, $event)"
                :placeholder="''"
                :selectOptions="getVariables"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="mt16">
        <div class="variable_title">
          <p>使用变量</p>
          <div class="icon_box">
            <el-tooltip class="item" effect="dark" content="显示变量路径提示文字" placement="left">
              <cx-check-box :value.sync="showSelectTooltip" class="mr8" />
            </el-tooltip>
            <div @click="addVariable" class="icon-portal-plus-small plugin_title"></div>
          </div>
        </div>
        <div v-for="(item, key) in variable" :key="key" class="variable_item mb8">
          <div class="right_font"><span @click="delVariable(key)" class="icon-portal-delete plugin_title"></span></div>
          <div class="variable_set mt16">
            <cx-select
              title="变量路径"
              :value="item.variablePath"
              @change="checkVariablePath(key, $event)"
              tooltipPosition="left"
              :showTooltip="showSelectTooltip"
              :selectOptions="getSelectOption"
            />
          </div>

          <div class="variable_set mt16">
            <div class="mr8 name">配置项值</div>
            <div class="variable_value">
              <el-input
                class="mr8"
                :value="item.matchValue"
                @input="changeVariableStr(key, $event)"
                @change="checkVariableValue(key, $event)"
                placeholder="请输入变量值"
              ></el-input>
              <cx-select
                class="variable-tips"
                :value="''"
                @change="selectVariable(item.matchValue, key, $event)"
                :placeholder="''"
                :selectOptions="getVariables"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <component
      v-if="componentName.toLowerCase().includes('container')"
      :is="componentName"
      :options="oldRectAttr"
      :container_id="rectIds.container_id"
      :rect_id="rectIds.rect_id"
    ></component>
    <div v-else>
      <component
        :is="componentName + 'Setting'"
        :options="oldRectAttr"
        :container_id="rectIds.container_id"
        :rect_id="rectIds.rect_id"
      ></component>
      <component
        :is="componentName + 'Data'"
        :options="oldRectAttr"
        :container_id="rectIds.container_id"
        :rect_id="rectIds.rect_id"
      ></component>
    </div>
    <div class="mt16 save_box">
      <div v-show="componentName.length" @click="saveEvent" class="save_edit">保存交互</div>
    </div>
  </div>
</template>

<script>
import { optionType } from "utils/event"
import toolbarMixin from "components/stageComponents/toolbar/toolBarMixIn.js"
import sliderAndInput from "../../../../modules/components/sliderAndInput.vue"
import { allGetOptDesEv } from "./utils/getRectOptDes.js"
import { isJSON, filterQuotation } from "utils"
class BaseVariable {
  constructor() {
    this.variableName = [] //变量名
    this.variablePath = "" //具体替换的数据在options中的位置
    this.matchValue = ""
  }
}
class BaseUrlParam {
  constructor(itemKey, itemValue, variableName) {
    this.itemKey = itemKey || ""
    this.itemValue = itemValue || ""
    this.variableName = variableName || []
  }
}
export default {
  components: { sliderAndInput },
  mixins: [toolbarMixin],
  model: {
    prop: "variable"
  },

  props: {
    variable: Array,
    responseRectIds: Object,
    innerElementLabel: String,
    eventUpdateType: String,
    transitionTime: [Object, Number],
    option: Array,
    componentVariables: Array,
    eventVariables: Array
  },
  data() {
    return {
      componentName: "",
      urlParam: [],
      rectIds: null,
      transition: false,
      transitionData: 0,
      optionTypeSelectOptions: optionType,
      showSelectTooltip: false,
      oldRectOptions: null,
      saved: false
    }
  },
  computed: {
    oldRectAttr() {
      return this.$getOptions({ ...this.responseRectIds })
    },
    getSelectOption() {
      const rectAttr = this.getAttrById(this.$store.state[this.request_prefix], this.responseRectIds)
      const opt = rectAttr.options ? rectAttr.options : rectAttr
      const shape = opt.innerElement
      return allGetOptDesEv[`get${shape[0].toUpperCase() + shape.slice(1)}OptDes`](opt)
    },
    getVariables() {
      return [].concat(this.componentVariables || [], this.eventVariables || []).map(it => {
        return {
          label: it.variableName,
          value: it.variableName
        }
      })
    },
    eventUpdateTypeProxy: {
      get() {
        return this.eventUpdateType
      },
      set(val) {
        this.$emit("update:eventUpdateType", val)
      }
    },
    transitionProxy: {
      get() {
        return this.transitionTimeProxy !== null
      },
      set(val) {
        this.transitionTimeProxy = val ? 0 : null
      }
    },
    transitionTimeProxy: {
      get() {
        return this.transitionTime
      },
      set(val) {
        this.$emit("update:transitionTime", val)
      }
    }
  },
  methods: {
    selectVariable(oldStr, key, variableName) {
      this.checkVariableValue(key, `${oldStr}((${variableName}))`)
    },
    selectUrlParamVariable(oldStr, key, variableName) {
      this.checkUrlParamValue(key, `${oldStr}((${variableName}))`)
    },
    checkUrlParamValue(key, str) {
      const { eventVariables, componentVariables } = this
      this.changeUrlParamValueStr(key, str.replaceAll("(())", "").replaceAll("{{}}", ""))
      this.$event
        .checkMatchStr(str, { eventVariables, componentVariables })
        .then(res => {
          const { variables } = res
          this.changeUrlParamVariableName(key, [])
          variables.length &&
            this.changeUrlParamVariableName(
              key,
              variables.map(variableDes => variableDes.variableName)
            )
        })
        .catch(err => {
          console.log(err)
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "warning",
            message: err.msg + ",已为您将错误数据保存至剪切板，请检查后重新输入"
          })
          this.copyToClip(str)
          this.changeUrlParamValueStr(key, "")
        })
    },
    checkVariableValue(key, str) {
      //首先处理空变量插值
      this.changeVariableStr(key, str.replaceAll("(())", "").replaceAll("{{}}", ""))
      const { eventVariables, componentVariables } = this
      this.$event
        .checkMatchStr(str, { eventVariables, componentVariables })
        .then(res => {
          const { variables } = res
          this.changeVariableName(key, [])
          variables.length &&
            this.changeVariableName(
              key,
              variables.map(variableDes => variableDes.variableName)
            )
        })
        .catch(err => {
          console.log(err)
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "warning",
            message: err.msg + ",已为您将错误数据保存至剪切板，请检查后重新输入"
          })
          this.copyToClip(str)
          this.changeVariableStr(key, "")
        })
    },
    checkVariablePath(key, value) {
      const stage = this.$store.state[this.request_prefix]
      let rectAttr = this.getAttrById(stage, this.$store.state.states.activeID)
      rectAttr = rectAttr.options ? rectAttr.options : rectAttr
      const names = value.split(".")
      for (let i = 0; i < names.length; i++) {
        if (rectAttr.hasOwnProperty(names[i])) {
          rectAttr = rectAttr[names[i]]
        } else {
          rectAttr = undefined
          break
        }
      }
      if (rectAttr === undefined) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "warning",
          message: `无效变量路径，已为您将错误值保存至剪切板，请检查后重新填写！`
        })
        this.copyToClip(value)
        this.changeVariablePath(key, "")
        return
      }
      this.changeVariablePath(key, value)
    },
    filterArray(value) {
      for (let i = 0; i < value.length; i++) {
        const itemName = value[i]
        let leftIndex = value.findIndex(it => it === itemName),
          rightIndex = value.findLastIndex(it => it === itemName)
        while (leftIndex !== rightIndex) {
          value.splice(rightIndex, 1)
          rightIndex = value.findLastIndex(it => it === itemName)
        }
      }
    },
    delUrlParam(index) {
      this.urlParam.splice(index, 1)
    },
    delVariable(index) {
      this.variable.splice(index, 1)
    },
    addUrlParamItem() {
      this.urlParam.push(new BaseUrlParam())
    },
    addVariable() {
      this.variable.push(new BaseVariable())
    },
    changeUrlParamVariableName(key, value) {
      this.filterArray(value)
      this.urlParam[key].variableName = value
    },
    changeVariableName(key, value) {
      this.filterArray(value)
      this.variable[key].variableName = value
    },
    changeVariablePath(key, value = value.trim()) {
      this.variable[key].variablePath = value
    },
    changeVariableStr(key, value = value.trim()) {
      this.variable[key].matchValue = value
    },
    changeUrlParamValueStr(key, value = value.trim()) {
      this.urlParam[key].itemValue = value
    },
    initComponentSettings(ids) {
      const stage = this.$store.state[this.request_prefix]
      const rectAttr = this.getAttrById(stage, ids)
      const rectOptions = rectAttr.options ? rectAttr.options : rectAttr
      const innerElement = rectOptions.innerElement
      const componentName = innerElement ? this.getComponentName(innerElement) : null
      this.$store.commit("states/changeActiveID", ids)
      this.componentName =
        componentName || (this.request_prefix === "bigScreen" ? "bigScreenContainerSetting" : "containerSetting")
      this.oldRectOptions = JSON.parse(JSON.stringify(rectOptions))
      this.rectIds = { ...ids }
    },
    getComponentName(shape) {
      if (shape.slice(0, 2) === "cx") {
        shape = shape.slice(2)
        return shape[0].toLowerCase() + shape.slice(1) + "Component"
      } else return shape
    },

    initUrlParamVariable() {
      const res = []
      this.urlParam.forEach((item, index, array) => {
        const itemQuery = new BaseVariable()
        itemQuery.variablePath = "eventQuery"
        let { itemValue, variableName } = item
        if (isJSON(itemValue)) {
          itemValue = Object.values(JSON.parse(itemValue))[0]
        }
        itemQuery.matchValue = filterQuotation(itemValue)
        variableName.forEach(name => {
          if (!itemQuery.variableName.find(it => it === name)) {
            itemQuery.variableName.push(name)
          }
        })
        res.push(itemQuery)
      })
      return res
    },
    hasUrlParam() {
      for (let i = 0; i < this.urlParam.length; i++) {
        let { itemValue, variableName } = this.urlParam[i]
        itemValue = String(itemValue)
        if (itemValue.trim().length === 0 || itemValue.includes("NaN") || itemValue.includes("undefined")) {
          //无效接口参数 做删除
          this.urlParam.splice(i--, 1)
        }
      }
      return this.urlParam.length
    },
    saveEvent() {
      const ids = this.responseRectIds
      const stage = this.$store.state[this.request_prefix]
      const rectAttr = this.getAttrById(stage, ids)
      //如果有事件参数变量并且事件参数变量为有效值 则把事件参数变量格式化为普通参数变量
      if (this.hasUrlParam()) this.variable.push(...this.initUrlParamVariable())
      const rectOptions = rectAttr.options ? rectAttr.options : rectAttr
      const options =
        this.eventUpdateTypeProxy === "diff"
          ? this.diffAttr(rectOptions, this.oldRectOptions)
          : JSON.parse(JSON.stringify(rectOptions))
      //更新组件相应配置中的options
      this.$emit("update:option", options)
      //还原配置项
      this.$store.dispatch(this.request_prefix + "/changeAllOptions", {
        ...ids,
        options: this.oldRectOptions,
        isEditEvent: true
      })
      //通知主组件 完成事件绑定
      this.$emit("save", "component", "option")
      this.saved = true
    },
    type(val) {
      return Object.prototype.toString.call(val)
    },
    diffAttr(n, o) {
      const res = []
      diff(JSON.parse(JSON.stringify(n)), JSON.parse(JSON.stringify(o)))
      return res
      function diff(n, o, path = "") {
        for (const nk in n) {
          if (Object.hasOwnProperty.call(o, nk)) {
            const nVal = n[nk],
              oVal = o[nk]
            if (
              //如果两个值不相等且 两个值中有一个值为非引用类型或者两个值均为基本数据类型.......等等一系列两个数据不相等的情况
              nVal !== oVal && //新老数据不相等
              (nVal === null || //新老数据任一为null
                oVal === null || //新老数据任一为null
                nVal === undefined || //新老数据任一为undefined
                oVal === undefined || //新老数据任一为undefined
                (Array.isArray(nVal) && Array.isArray(nVal) && nVal.length !== oVal.length) ||
                (typeof nVal !== "object" && typeof oVal !== "object") || //新老数据均不为引用类型
                (typeof nVal === "object" && typeof oVal !== "object") || //老数据为引用类型 新数据为非引用类型
                (typeof nVal !== "object" && typeof oVal === "object")) //新数据为引用类型 老数据为非引用类型
            ) {
              //直接更新
              res.push({ path: path.length ? path + "." + nk : nk, value: nVal })
            } else if (
              //如果新老数据不一致 且新老数据都为引用类型
              (nVal !== oVal && typeof nVal === "object" && typeof oVal === "object") ||
              (Array.isArray(nVal) && Array.isArray(oVal) && nVal.length === oVal.length) //且 如果新老数据为数组且长度一致
            ) {
              diff(nVal, oVal, path.length ? path + "." + nk : nk)
            }
          }
        }
      }
    },
    initOptions() {
      if (this.option.length) {
        this.option.forEach(change => {
          this.$changeOptionsEV(change.value, change.path, false, null, { ...this.responseRectIds })
        })
      }
    },
    initUrlParamSetting() {
      // "eventQuery"
      console.log("this.variable :>> ", this.variable)
      const index = this.variable.findIndex(it => it.variablePath === "eventQuery")
      for (let i = 0; i < this.variable.length; i++) {
        let { matchValue, variablePath, variableName } = this.variable[i]
        if (variablePath === "eventQuery") {
          this.urlParam.push(
            new BaseUrlParam(
              "",
              isJSON(matchValue) ? filterQuotation(matchValue.split(":")[1].slice(0, -1)) : matchValue,
                variableName
            )
          )
          this.variable.splice(i--, 1)
        }
      }
      console.log("this.urlParam :>> ", this.urlParam, this.variable)
      // if (index !== -1) {
      //   const itemVariable = this.variable[index]
      //   let { matchValue, variablePath, variableName } = itemVariable
      //   const time = String(new Date().getTime()).slice(6)
      //   variableName.forEach((name, index) => {
      //     const matchStr = `((${name}))`
      //     let strIndex = matchValue.indexOf(matchStr)
      //     if (strIndex !== -1) {
      //       //大于等于2的情况下 前面才放得下 斜杠星号(\*)
      //       const isStringType =
      //         strIndex >= 2 &&
      //         matchValue.length >= matchStr.length + 4 &&
      //         matchValue.slice(strIndex - 2, 1) === matchValue.slice(strIndex + matchStr.length, 1)
      //           ? true
      //           : false
      //       matchValue = matchValue.replaceAll(
      //         matchStr,
      //         (isStringType ? `\\"` : "") + time + index + (isStringType ? `\\"` : "")
      //       )
      //     }
      //   })
      //   const urlQueryData = JSON.parse(matchValue)
      //   for (let k in urlQueryData) {
      //     const tarUrlParam = new BaseUrlParam()
      //     tarUrlParam.itemKey = "filterValue"
      //     variableName.forEach((name, index) => {
      //       if (String(urlQueryData[k]).includes(time + index)) {
      //         urlQueryData[k] = String(urlQueryData[k]).replaceAll(time + index, `((${name}))`)
      //       }
      //     })
      //     tarUrlParam.itemValue = urlQueryData[k]
      //     tarUrlParam.variableName = [...variableName]
      //     this.urlParam.push(tarUrlParam)
      //   }
      //   this.variable.splice(index, 1)
      // }
    }
  },
  beforeCreate() {
    //用于组件elementType切换时不触发toolbar切换组件样式
    window.sessionStorage.setItem("isSettingEvent", true)
  },

  created() {
    this.initComponentSettings(this.responseRectIds)
    this.initUrlParamSetting() //如果使用变量里有接口参数变量 则格式化为接口参数变量
    this.initOptions() //初始化配置项 兼容从编辑事件中进入的场景
  },
  beforeDestroy() {
    window.sessionStorage.removeItem("isSettingEvent")
    if (!this.saved) {
      //组件被删除时如果没有点保存 则还原组件配置项
      this.$store.dispatch(this.request_prefix + "/changeAllOptions", {
        ...this.responseRectIds,
        options: this.oldRectOptions
      })
    }
  }
}
</script>

<style scoped>
.save_box {
  padding: 0 24px;
}
.save_edit {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 70px;
}
.save_edit:hover {
  cursor: pointer;
}
.update_settings {
  padding: 16px 24px;
}
.variable_set {
  display: flex;
  align-items: center;
}
.param_name {
  width: 20%;
}
.param_value {
  width: 80%;
  display: flex;
}
.name {
  width: 30%;
}
.variable_value {
  width: 70%;
  display: flex;
}
.variable_title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.icon_box {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  font-size: 18px;
}
.right_font {
  text-align: right;
}
.plugin_title {
  display: inline-block;
}
.plugin_title:hover {
  cursor: pointer;
}
.variable_item {
  border: 1px solid gray;
  padding: 10px 15px;
  border-radius: 4px;
}
.variable-tips {
  width: 20px;
}
.variable-tips::v-deep .el-input__suffix {
  right: 0px;
}
</style>
